import { render, staticRenderFns } from "./BoxEdit.vue?vue&type=template&id=59722cf1&scoped=true&"
import script from "./BoxEdit.vue?vue&type=script&lang=js&"
export * from "./BoxEdit.vue?vue&type=script&lang=js&"
import style0 from "./BoxEdit.vue?vue&type=style&index=0&id=59722cf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59722cf1",
  null
  
)

export default component.exports